import { BASE_SELECT_DEFAULT_MODE, BASE_SELECT_DEFAULT_SIZE } from '../../common/BaseSelect/BaseSelect.constants';
// Constants.
// -----------------------------------------------------------------------------
/** Default disabled value. */
export const SELECT_MULTI_DEFAULT_DISABLED = false;
/** Default match order. */
export const SELECT_MULTI_DEFAULT_MATCH_ORDER = false;
/** Default mode. */
export const SELECT_MULTI_DEFAULT_MODE = BASE_SELECT_DEFAULT_MODE;
/** Default placeholder. */
export const SELECT_MULTI_DEFAULT_PLACEHOLDER = '';
/** Default size. */
export const SELECT_MULTI_DEFAULT_SIZE = BASE_SELECT_DEFAULT_SIZE;
//# sourceMappingURL=SelectMulti.constants.js.map